import { HeadingPages } from '../../components/HeadingPages'
import { FiltroPedido } from './FiltroPedido'
import { ListaPedido } from './ListaPedido'
import { api } from '../../services/api'
import { useForm } from 'react-hook-form'
import { useQuery } from 'react-query'
import { formatPrice } from '../../utils/formatPrice'

import { format } from 'date-fns'
import { Center, Flex, TableContainer, useMediaQuery } from '@chakra-ui/react'
import * as T from '../../components/Table'
import { BsPrinter } from 'react-icons/bs'

async function getPedidos({ codVendedor, dataInicio, dataFim, numeroPedido, statusEntrega }) {
  const response = await api.get(`/site/v2/tracken/controle-informacoes-transportadora`, {
    params: {
      codigo_vendedor: codVendedor,
      data_inicial: dataInicio,
      data_final: dataFim,
      numero_pedido: numeroPedido,
      status_entrega: statusEntrega,
    },
  })

  return response.data.map((item) => {
    return {
      ...item,
      ultima_atualizacao: item.ultima_atualizacao ? format(new Date(item.ultima_atualizacao), "dd/MM/yyyy 'às' HH:mm") : '-',
      destinatario: item.destinatario?.toLowerCase() || '-',
      cliente: item.cliente?.toLowerCase() || '-',
      valor_nota: formatPrice(item.valor_nota) || '-',
      prazo_entrega: `${item.prazo_entrega} dia(s)` || '-',
      previsao_saida: item.data_saida ? format(new Date(item.data_saida), "dd/MM/yyyy 'às' HH:mm") : '-',
      data_aprovacao: item.data_aprovacao,
      data_coleta: item.data_coleta ? format(new Date(item.data_coleta), "dd/MM/yyyy 'às' HH:mm") : '-',
      status_entregue: item.status_entregue
        ? {
            nome_usuario: item.status_entregue.nome_usuario || '-',
            data_entregue: item.status_entregue.data_entregue ? format(new Date(item.status_entregue.data_entregue), "dd/MM/yyyy 'às' HH:mm") : '',
          }
        : { nome_usuario: '-', data_entregue: '-' },
    }
  })
}

export function RastreioJ3() {
  const { handleSubmit, register, watch } = useForm({
    defaultValues: {
      numeroPedido: '',
      codVendedor: '',
      dataInicio: '',
      dataFim: '',
      statusEntrega: '5',
    },
  })

  //maxWidth 1200px
  const [isLargerThan1366px] = useMediaQuery('(max-width: 1366px)')

  const numeroPedido = watch('numeroPedido') || ''
  const codVendedor = watch('codVendedor') || ''
  const dataInicio = watch('dataInicio') || ''
  const dataFim = watch('dataFim') || ''
  const statusEntrega = watch('statusEntrega') || ''

  const {
    refetch,
    isLoading,
    data: dataRastreio,
  } = useQuery({
    queryKey: ['getPedidos'],
    queryFn: () =>
      getPedidos({
        codVendedor,
        dataInicio,
        dataFim,
        numeroPedido,
        statusEntrega,
      }),

    staleTime: 1000 * 60 * 5, // 5 minutos
  })

  async function handleFilter(data) {
    refetch()
  }

  return (
    <>
      <HeadingPages name="Rastreio J3" />
      <FiltroPedido register={register} handleSubmit={handleSubmit(handleFilter)} isLoading={isLoading} />

      <TableContainer
        maxW="1600px"
        mx="auto"
        maxH="70vh"
        overflowY="auto"
        p={2}
        {...(isLargerThan1366px && {
          maxW: '1316px',
          maxH: '65vh',
        })}
      >
        <T.Table variant="outline" borderCollapse="collapse">
          <T.Thead>
            <T.Tr>
              <T.Th>Pedido</T.Th>
              <T.Th>NFE</T.Th>
              <T.Th>Nome Cliente</T.Th>
              <T.Th>Status Atual</T.Th>
              <T.Th>Histórico</T.Th>
              <T.Th>Destinatário</T.Th>
              <T.Th>Código Remessa</T.Th>
              <T.Th>Valor pedido</T.Th>
              <T.Th>Prazo Entrega</T.Th>
              <T.Th>Previsão Saída</T.Th>
              <T.Th>Data Coleta</T.Th>
              <T.Th>Data Entrega</T.Th>
              <T.Th>Entregue</T.Th>
              <T.Th>Cancelar</T.Th>
              <T.Th textAlign="center">
                <Flex alignItems="center" gap={1} mx="auto" justifyContent="center">
                  Imprimir
                  <BsPrinter size="25px" color="#fff" />
                </Flex>
              </T.Th>
            </T.Tr>
          </T.Thead>
          <T.Tbody>
            {isLoading && (
              <T.Tr>
                <T.Td colSpan="14">
                  <Center>Carregando...</Center>
                </T.Td>
              </T.Tr>
            )}
            {!isLoading && dataRastreio?.length === 0 && (
              <T.Tr>
                <T.Td colSpan="14">
                  <Center>Nenhum pedido encontrado</Center>
                </T.Td>
              </T.Tr>
            )}
            <ListaPedido data={dataRastreio} />
          </T.Tbody>
        </T.Table>
      </TableContainer>
    </>
  )
}
